import React from 'react';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router-dom';

import './userProfileMenu.scss';
import {DropdownMenu, DropdownMenuLink} from '../../../../../@elixir/router';
import {Button} from '../../../../../@elixir/components';
import {GetRequest} from '../../../common/service/GetRequest';

class UserProfileMenu extends React.Component {

    static propTypes = {};

    static contextTypes = {
        translator: PropTypes.func.isRequired
    };

    constructor (props) {
        super(props);

        this.state = {
            isDropdownMenuOpen: false,
            firstName: ''
        };
    }

    componentDidMount () {
        const profileUrl = '/rest/User/profile';
        new GetRequest(profileUrl).then(
            (result) => {
                this.setState({firstName: result.firstName});
            }
        );
    }

    onLogout (event) {
        event.preventDefault();
        window.localStorage.removeItem('loginToken::operator');
        this.props.history.push('/login');
    }

    onSelectMenuItem (event, menuItem) {
        event.preventDefault();
    }

    render () {
        const {
            firstName
        } = this.state;

        return (
            <DropdownMenu
                className="userProfileMenuComponent"
                renderTrigger={(props, toggleMenu) => {
                    const {isOpen, className} = props;
                    const handleButtonClick = () => {
                        toggleMenu(!isOpen);
                    };

                    return <Button className="backButton"
                                   name="backButton"
                                   type="neutral"
                                   size="small"
                                   icon="user"
                                   onClick={handleButtonClick.bind(this)}>
                        <span>{firstName}</span>
                    </Button>;


                }}
                dropUp={false}
                alignRight={true}
                showCaret={false}>

                <DropdownMenuLink disabled
                                  key="about"
                                  onClick={this.onSelectMenuItem.bind(this)}>
                    <span>{this.context.translator('userProfileMenu.aboutOperatorButtonLabel')}</span>
                </DropdownMenuLink>

                <DropdownMenuLink disabled
                                  onClick={this.onSelectMenuItem.bind(this)}
                                  key="resetPassword">
                    <span>{this.context.translator('userProfileMenu.resetPasswordButtonLabel')}</span>
                </DropdownMenuLink>

                <DropdownMenuLink onClick={this.onLogout.bind(this)}
                                  key="logout">
                    <span>{this.context.translator('userProfileMenu.logoutButtonLabel')}</span>
                </DropdownMenuLink>

            </DropdownMenu>
        );
    }
}

export default withRouter(UserProfileMenu);

